import hash from 'object-hash';
import {getPropValues} from 'helpers/array-helper';
import NumberHelper from 'helpers/number-helper';

export function createChecksumForLineupPlayers(lineupPlayers: object[]): string {
    const playerIds = getPropValues(lineupPlayers, 'playerId');

    const sortedPlayerIds = playerIds.sort();

    return hash(sortedPlayerIds);
}

export function generateRandomKey(length = 6): string {
    const chars = ['a', 'b', 'c', 'd', 'e', 'f'];
    const index = NumberHelper.getRandomInt(0, chars.length);

    const tailLength = length - 1;

    return (
        chars[index] +
        Math.random()
            .toString(16)
            .slice(-1 * tailLength)
    );
}

export function generateSignature(length = 6): string {
    return generateRandomKey(length);
}
